<template>
  <ActicsLeftMenu>
    <template #app>
      <div class="hvh-flex column">
        <router-link class="nexa-black extra-bold p-3" :to="{ name: 'medInsights' }" v-if="getFlag('DAS-701')">M</router-link>
        <v-divider />
        <router-link class="p-3" :to="{ name: 'enterpriseMetrics' }" v-if="getFlag('DAS-826')"><span class="nexa-black extra-bold">E</span>M</router-link>
        <v-divider />
        <router-link class="nexa-black extra-bold p-3" :to="{ name: 'itOperations' }" v-if="getFlag('DAS-1006')">IT</router-link>
      </div>
    </template>
  </ActicsLeftMenu>
</template>

<script>
import ActicsLeftMenu from '../layout/actics/ActicsLeftMenu.vue'
export default {
  components: { ActicsLeftMenu },
}
</script>

<style lang="scss" scoped>
.router-link-active {
  background-color: rgba(133, 199, 211, 0.23);
}
</style>